<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003606.installation.bidon.titre' | translate"
      [description]="'P0003606.installation.bidon.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [nameCustom]="'P0003606.installation.installe' | translate"
      [value]="actionStack!.getValue('iphIDetecteurFinBidonInstalle') !== 0"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionPh_Installation,
          'iphIDetecteurFinBidonInstalle',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (this.actionStack!.getValue('iphIDetecteurFinBidonInstalle') === 1) {
      <app-label-configuration
        [titleListe]="'P0003606.installation.contact' | translate"
        [value]="actionStack!.getValue('iphISensContactFinBidon')"
        [liste]="P0003606SensContactEnum"
        (onPress)="goDetectionModal($event)"
      >
      </app-label-configuration>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
